module.exports = __webpack_public_path__ + "assets/img/xnlb_icon.57281f6b.jpg";